<template>
  <div class="profil">
        <!-- main-area -->
        <main class="fix">
            <!-- breadcrumb-area -->
            <section class="breadcrumb__area breadcrumb__bg">
                <div class="bg-img position-absolute top-0 start-0 w-100 h-100" data-background="assets/img/bg/breadcrumb_bg.jpg"></div>
                <div class="container">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="breadcrumb__content">
                                <h2 class="title">Layanan Pengaduan</h2>
                                <nav aria-label="breadcrumb">
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item"><router-link to="/">Beranda</router-link></li>
                                        <li class="breadcrumb-item active" aria-current="page">Layanan Pengaduan Kekerasan Terhadap Perempuan & Anak</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="breadcrumb__shape">
                    <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
                    <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
                </div>
            </section>
            <!-- breadcrumb-area-end -->
            <section class="contact__area">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-5">
                            <div class="contact__content">
                                <div class="section-title mb-35">
                                    <h2 class="title">Layanan Pengaduan <i class="fas fa-hand-holding-heart"></i></h2>
                                    <p>Layanan Pengaduan Kekerasan Terhadap Perempuan dan Anak Dinas Pemberdayaan Perempuan dan Perlindungan Anak Kabupaten Konawe Selatan</p>
                                </div>
                                <div class="contact__info">
                                    <ul class="list-wrap">
                                        <li>
                                            <div class="icon">
                                                <i class="flaticon-pin"></i>
                                            </div>
                                            <div class="content">
                                                <h4 class="title">Alamat</h4>
                                                <p>Jalan Poros Andoolo, Konawe Selatan, Sulawesi Tenggara</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                                <i class="flaticon-phone-call"></i>
                                            </div>
                                            <div class="content">
                                                <h4 class="title">Telepon</h4>
                                                <a href="tel:0123456789">+62 852 4164 4512</a>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="icon">
                                                <i class="flaticon-mail"></i>
                                            </div>
                                            <div class="content">
                                                <h4 class="title">E-mail</h4>
                                                <a href="mailto:dpppa@konaweselatankab.go.id">dpppa@konaweselatankab.go.id</a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-7">
                            <div class="contact__form-wrap">
                                <h2 class="title pb-2">Kirim Aduan Anda</h2>
                                <form  @submit.prevent="addData()">
                                    <div class="form-grp">
                                        <textarea v-model="form.deskripsi" placeholder="Pesan"></textarea>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="form-grp">
                                                <input type="text" v-model="form.judul" placeholder="Nama" />
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="form-grp">
                                                <input type="number" v-model="form.no_hp" placeholder="Telepon" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-grp">
                                        <input @change="onFileSelected"  type="file" placeholder="Foto" />
                                    </div>
                                    <button type="submit" class="btn">Kirim Aduan</button>
                                </form>
                                <p class="ajax-response mb-0"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- contact-area-end -->
        </main>
        <!-- main-area-end -->
  </div>
</template>

<script>

export default {
  name: 'Profil',

  data () {
    return {
        file_path: this.$store.state.url.URL_APP + "uploads/",
        unit_kerja: this.$store.state.UNIT_KERJA,
        form : {
            id : '',
            judul : '',
            sumber : '',
            deskripsi : '',
            uraian : '',
            foto : '',
            no_hp : '',
            unit_kerja : 'Rakyat',
            status : '0',
            keterangan : 'NULL',
        },
    }
  },

  methods: {
    onFileSelected: function(event) {
      this.form.foto = event.target.files[0];
    },
    addData: function() {
        console.log('====================================');
        console.log(this.$store.state.url.URL_LAYANAN);
        console.log('====================================');
        var formData = new FormData();

        formData.append("judul", this.form.judul);
        formData.append("deskripsi", this.form.deskripsi);
        formData.append("no_hp", this.form.no_hp);
        formData.append("file", this.form.foto);
        formData.append("unit_kerja", this.form.unit_kerja);

        fetch(this.$store.state.url.URL_LAYANAN + "addData", {
            method: "POST",
            body: formData
        }).then(res_data => {
            console.log(res_data);
            
            alert("Berhasil Mengirim Pengaduan");
        });
    },
  },
}
</script>
